import { default as CodeText } from './CodeText';
import { default as EllipsisText } from './EllipsisText';
import { default as FormSectionTitle } from './FormSectionTitle';
import { default as LinkText } from './LinkText';
import { default as MarkdownBlock } from './MarkdownBlock';
import { default as PageTitle } from './PageTitle';
import { default as SecondaryText } from './SecondaryText';
import { default as SectionTitle } from './SectionTitle';
import { default as StatisticLabel } from './StatisticLabel';
import { default as StatisticValue } from './StatisticValue';
import { default as TerminalText } from './TerminalText';
import { default as Text } from './Text';

export type { CodeTextProps, CodeTextVariant } from './CodeText';
export type { MarkdownProps, MarkdownVariant } from './MarkdownBlock';
export type { FontSize, FontWeight, TextColor, TextProps } from './Text';

export const Typography = {
    CodeText,
    EllipsisText,
    FormSectionTitle,
    LinkText,
    MarkdownBlock,
    PageTitle,
    SecondaryText,
    SectionTitle,
    StatisticLabel,
    StatisticValue,
    TerminalText,
    Text,
};

export default Typography;
